import { Stack } from '@mui/material';
import { RachelProductCardsTestIds } from '../../../../../utils/testIds/RachelProductCards.testIds';
import ProductCardsBlockItem from './components/ProductCardsBlockItem/ProductCardsBlockItem';
import ProductCardsCarousel from './components/ProductCardsCarousel/ProductCardsCarousel';
import { ProductCardsBlock as ProductCardsBlockType } from './productCardsBlock.types';
import { useProductCardsBlock } from './useProductCardsBlock';

interface ProductCardsBlockProps {
  block: ProductCardsBlockType;
}

const ProductCardsBlock = ({ block }: ProductCardsBlockProps) => {
  const { products, isCarousel } = useProductCardsBlock(block);

  if (products.length === 0) {
    return null;
  }

  if (isCarousel) {
    return (
      <ProductCardsCarousel label={block.title}>
        {products.map((product) => (
          <ProductCardsBlockItem key={product.productColorId} product={product} variant="card" />
        ))}
      </ProductCardsCarousel>
    );
  }

  return (
    <Stack
      role="list"
      aria-label={block.title}
      test-id={RachelProductCardsTestIds.LIST}
      sx={{ minWidth: 0 }}
    >
      {products.map((product) => (
        <ProductCardsBlockItem key={product.productColorId} product={product} variant="row" />
      ))}
    </Stack>
  );
};

export default ProductCardsBlock;
